document.addEventListener("DOMContentLoaded", () => {
  const select = document.getElementById("productSelect");
  const button = document.getElementById("submitReview");
  if (!select || !button) return;

  select.addEventListener("change", (e) => {
    const productId = e.target.value;
    if (productId) {
      button.classList.remove("hidden");
      button.dataset.id = productId;
      button.setAttribute("aria-disabled", "false");
    } else {
      button.classList.add("hidden");
      delete button.dataset.id;
      button.setAttribute("aria-disabled", "true");
    }
  });

  button.addEventListener("click", (e) => {
    e.preventDefault();
    const productId = button.dataset.id;
    if (productId) BV.ui("rr", "submit_review", { productId });
  });
});
